import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import PanoramaFishEyeIcon from "@mui/icons-material/PanoramaFishEye";
import { Box, CircularProgress, Typography, Checkbox, IconButton } from "@mui/material";
import SearchBar from "material-ui-search-bar";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { updateSnackbar } from "../../_redux/SnackbarSlice";
import Pagination from "../../components/DynamicTable/Pagination";
import DynamicTable from "../../components/DynamicTable/DynamicTable";
// import { DocumentViewer } from "react-documents";
import DocumentViewer from "../../components/DocumentViewer/DocumentViewer";
import { useDispatch, useSelector } from "react-redux";
import RightSideBar from "../../components/Rightsidebar/RightSideBar";
import * as _ser from "../../_redux/_services/ApplicantsSlice";
import GetJobId from "../../_utilities/GetJobId";
import { GetTimeZone } from "../../_utilities/GetTimeZone";
import "./AssociateCards.css";
import { setBreadCrumb } from "../../_utilities/breadCrumb";

const initalState = { data: null, message: "", isloader: true };

const AssociateCards = ({
  data,
  selectedItems,
  isAImatched,
  onReceiveHandler,
  componentType,
  navigateTo,
  config,
  searchKeyWord,
  documentData,
  showSearchBar = true,
  isAssociate = null,
  alreadyAssociatedIds = [],
}) => {
  const [jobData, setjobData] = useState([]);
  const [searchValue, setSearchValue] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [jobRawData, setJobRawData] = useState(JSON.stringify(data));
  const [aiSearchData, setAiSearchData] = useState();
  const [currentPage, setCurrentPage] = useState(config.currentPage);
  const [totalRecords, setTotalRecords] = useState(data.length);
  const [isNoData, setIsNoData] = useState(false);
  const [showResumes, setShowResumes] = useState("");
  const [selectedResume, setSelectedResume] = useState({});
  const [isRightSidePannel, setIsRightSidePannel] = useState(false);
  const [documents, setDocuments] = useState([]);
  const [previewType, setPreviewType] = useState("");
  const [actionType, setActionType] = useState("");
  const [selectedDocId, setSelectedDocId] = useState([]);
  let usersPerPage = componentType === "AssociatedProjects" ? 6 : 9;

  const dispatch = useDispatch();

  const JobId = GetJobId();

  useEffect(() => {
    if (selectedItems.length > 0) {
      let Ids = [];
      let docsIds = [];
      selectedItems.forEach((element) => {
        if (element) {
          Ids.push(element.id);
          docsIds.push(element.docId);
        }
      });
      setSelectedIds(Ids);
      setSelectedDocId(docsIds);
    } else {
      setSelectedIds([]);
    }
  }, [selectedItems]);

  useEffect(() => {
    let cardData = JSON.parse(JSON.stringify(data));
    if (cardData && cardData.length > 0) {
      if (componentType === "AssociatedJobs") {
        cardData.forEach((list) => {
          if (selectedIds.includes(list.id) && selectedItems.length > 0) {
            let index = selectedItems.findIndex((x) => x.id == list.id);
            if (index !== -1) {
              list["docName"] = selectedItems[index].documentName || "";
              list["lastUpdated"] = selectedItems[index].lastUpdated
                ? GetTimeZone(selectedItems[index].lastUpdated)
                : "";
              list["uploadedBy"] = selectedItems[index].uploadedBy || "";
              list["associatedDocId"] = selectedItems[index].docId;
            }
          }
          if (documentData.length == 1) {
            list["docId"] = documentData[0].id;
          }
        });
        if (documentData && documentData.length > 0) {
          setDocuments(documentData);
        }
      } else if (componentType === "AssociatedProjects") {
        setjobData(data);
      } else {
        cardData?.forEach((list) => {
          if (list.docsarray) {
            let formatVal = "[" + list.docsarray + "]";
            list.docsarray = JSON.parse(formatVal);
            if (list.docsarray.length == 1) {
              list.docId = list.docsarray[0].docsid;
            }
            list.docsarray.forEach((doc) => {
              doc.docscreatedDate = GetTimeZone(doc.docscreatedDate);
              doc.uploadedBy = doc?.submittedByName;
            });
          }

          if (selectedIds.includes(list.id) && selectedItems.length > 0) {
            let index = selectedItems.findIndex((x) => x.id == list.id);
            let docIndex;
            if (!list.score && list?.docsarray !== "") {
              docIndex = list?.docsarray?.findIndex(
                (x) => x.docsid === selectedItems[index]?.docId,
              );
            }
            if (
              index !== -1 &&
              (list.score
                ? list.docsId == selectedItems[index].docId
                : docIndex !== -1)
            ) {
              list["docName"] = list?.score
                ? list?.documentName
                : list?.docsarray[docIndex]?.name;
              list["docLastUpdated"] = list.score
                ? GetTimeZone(list?.docscreatedDate)
                : GetTimeZone(list?.docsarray[docIndex]?.docscreatedDate);
              list["docUploadedBy"] = list.score
                ? list?.documentSubmittedBy
                : list.docsarray[docIndex]?.submittedByName;
              list["associatedDocId"] = list.score
                ? list.docsId
                : list.docsarray[docIndex]?.docsid;
            }
          }
        });
      }
      if ((searchValue && searchValue !== "") || isAImatched) {
        if (cardData.length > usersPerPage) {
          let data = cardData.slice(
            (currentPage !== 1 ? currentPage - 1 : 0) * usersPerPage,
            currentPage * usersPerPage,
          );
          setjobData(data);
        } else {
          setjobData(cardData);
        }
      }
      if (!isAImatched && !searchValue) {
        setjobData(cardData);
      }
      setTotalRecords(
        componentType === "AssociatedApplicants"
          ? cardData[0].total_count
            ? cardData[0].total_count
            : config.totalRecords
          : componentType === "AssociatedProjects"
            ? config.totalRecords
            : componentType === "AssociatedJobs"
              ? config.totalRecords
              : cardData.length,
      );
      setJobRawData(JSON.stringify(cardData));
    } else {
      setjobData([]);
      if (searchValue) {
        setIsNoData(true);
      }
    }
    setShowResumes("");
  }, [data, documentData, selectedItems, selectedIds]);

  const handleActionClick = (obj) => {
    let currentpage = obj - 1;
    let limitObj = {
      limit: usersPerPage,
      offset: currentpage * usersPerPage + 1,
      currentPage: obj,
      keyword: searchValue ? searchValue : "",
    };
    setCurrentPage(obj);
    onReceiveHandler(limitObj, "searchResult");
    let DataNew;
    if (aiSearchData) {
      DataNew = aiSearchData;
    } else {
      DataNew = JSON.parse(jobRawData);
    }
    if (DataNew.length > usersPerPage) {
      let Data = DataNew.slice(currentpage * usersPerPage, obj * usersPerPage);
      setjobData(Data);
    } else {
      setjobData(DataNew);
    }
  };

  const onSelectHandler = (item, doc) => {
    let dataArray = JSON.parse(JSON.stringify(selectedIds));
    let selectedDocIdArray = Array.isArray(selectedDocId)
      ? selectedDocId.filter((id) => id != null)
      : [];
    let findIndex = dataArray.findIndex((x) => x === item.id);
    let findDocIndex = selectedDocIdArray?.findIndex((x) =>
      x === item.docsId
        ? item.docsId
        : item.docId
          ? item.docId
          : item.associatedDocId
            ? item.associatedDocId
            : "",
    );
    if (
      findIndex !== -1 &&
      ((selectedDocIdArray.length > 0 && componentType === "AssociatedJobs") ||
      isAssociate === false
        ? findDocIndex !== -1
        : true) &&
      !doc
    ) {
      dataArray.splice(findIndex, 1);
      if (componentType === "AssociatedJobs") {
        let obj = { id: parseInt(item.id), jobCode: item.jobCode };
        onReceiveHandler(obj, "delete");
        setShowResumes("");
      } else if (componentType === "AssociatedApplicants") {
        let obj = { id: parseInt(item.id), applicantCode: item.applicantCode };
        onReceiveHandler(obj, "delete");
        setShowResumes("");
      }
    } else if (
      findIndex === -1 ||
      findDocIndex === -1 ||
      item.associatedDocId !== doc.docsid
    ) {
      if (componentType === "AssociatedJobs") {
        if (isAssociate !== false) {
          let obj = {
            id: parseInt(item.id),
            jobCode: item.jobCode,
            docId: doc ? doc.id : item.docId,
            keyword: searchValue,
            firstName: doc?.firstName,
            lastName: doc?.lastName,
          };
          onReceiveHandler(obj, "add");
        } else {
          dataArray = [parseInt(item.id)];
          onReceiveHandler(item, "linkNewApplicantToJob");
        }
      } else if (componentType === "AssociatedApplicants") {
        let obj = {
          id: parseInt(item.id),
          applicantCode: item.applicantCode,
          docId: doc ? doc.docsid : item.docId ? item.docId : item.docsId,
          score: item.score ? item.score : "",
          source: item.source ? item.source : "ATS",
          userId: item.userId,
          firstName: doc
            ? doc.submittedByName
            : item.docsarray
              ? item.docsarray[0].submittedByName
              : item.documentSubmittedBy,
          lastName: "",
        };
        onReceiveHandler(obj, "add");
      }
      dataArray.push(parseInt(item.id));
      if (componentType !== "AssociatedJobs") {
        alreadyAssociatedIds.push(parseInt(item.id));
      }
    }
    setSelectedIds(dataArray);
  };

  const onSearchhandler = (value, type) => {
    value = value.trimStart();
    // onReceiveHandler(null, 'linkNewApplicantToJob');
    // if(isAssociate === false){setSelectedIds([])}
    if (value.length < 2 && type === "onRequestSearch") {
      dispatch(
        updateSnackbar({
          type: "error",
          message: "Required Minimum 2 Characters",
        }),
      );
    }
    if (config.isSearchServer === false) {
      const rawData = JSON.parse(jobRawData);
      if (value !== "") {
        value = value.trimStart();
        setSearchValue(value);
        if (rawData) {
          if (value.length > 1) {
            let data1 = rawData.filter((x) =>
              Object.keys(x).some((k) =>
                String(x[k]).toLowerCase().includes(value.toLowerCase()),
              ),
            );
            if (data1.length > 0) {
              // setjobData(data1);
              setAiSearchData(data1);
              setIsNoData(false);
              setTotalRecords(data1.length);
              setjobData(data1.slice(0, usersPerPage));
            } else {
              setjobData("");
              setIsNoData(true);
            }
          } else {
            setAiSearchData();
            setjobData(rawData); // setjobData(rawData.slice(0, (usersPerPage)));
            setTotalRecords(rawData[0].total_count); //  setTotalRecords(rawData.length);
            setIsNoData(true);
          }
          setCurrentPage(1);
        }
      } else if (value === "" && type === "onCancelSearch") {
        setCurrentPage(1);
        setAiSearchData();
        setjobData(rawData); // setjobData(rawData.slice(0, (usersPerPage)));
        setTotalRecords(rawData[0].total_count); //  setTotalRecords(rawData.length);
        setIsNoData(false);
      }
    } else if (config.isSearchServer === true) {
      if (value !== "" && value.length >= 2) {
        value = value.trimStart();
        setSearchValue(value);
        setCurrentPage(1);
        setIsNoData(false);
        let limitObj = {
          limit: usersPerPage,
          offset: 1,
          currentPage: currentPage,
          keyword: value,
        };
        onReceiveHandler(limitObj, "searchResult");
      } else if (value === "") {
        setSearchValue(value);
        setIsNoData(false);
        setjobData([]);
        setCurrentPage(1);
        let limitObj = {
          limit: usersPerPage,
          offset: 1,
          currentPage: currentPage,
          keyword: value,
        };
        onReceiveHandler(limitObj, "searchResult");
      }
    }
  };

  const onNavigeteInNew = (e, object) => {
    e.stopPropagation();
    let Name = "";
    let type = "";
    if (object.applicantCode) {
      Name = `${object.firstName} ${object.lastName}`;
      type = "Applicant Code";
    } else if (object.jobCode) {
      Name = `${object.jobTitle} (${object.jobCode})`;
      type = "Job Code";
    }
    setBreadCrumb(object.id, Name, type);
    window.open(navigateTo + object.id, "_blank", "noopener,noreferrer");
  };

  const handleShowResumes = (object) => {
    if (isAssociate !== false) {
      setSelectedResume(
        componentType === "AssociatedApplicants" ? object : documents[0],
      );
      if (
        showResumes === "" &&
        (componentType !== "AssociatedApplicants"
          ? documents.length > 1
          : object.docsarray?.length > 1)
      ) {
        setShowResumes(object);
      } else if (
        showResumes === "" &&
        (componentType !== "AssociatedApplicants"
          ? documents.length == 1 || documents.length == 0
          : object.docsarray
            ? object.docsarray?.length == 1
            : true)
      ) {
        if (selectedIds.includes(parseInt(object.id))) {
          onSelectHandler(object);
        } else {
          onSelectHandler(object, documents[0]);
        }
      } else if (showResumes) {
        setShowResumes("");
      }
    } else {
      setSelectedResume(documents[0]);
      onSelectHandler(object, documents[0]);
    }
  };

  useEffect(() => {
    documents.forEach((item) => {
      item.docscreatedDate = GetTimeZone(item.docscreatedDate);
    });
  }, [showResumes]);

  const onReceiveActionHandler = async (type, object) => {
    if (type === "associateApplicant") {
      setSelectedResume(object);
      // let docId = componentType === "AssociatedJobs" ? object.id : object.docsid;
      onSelectHandler(showResumes, object);
      setShowResumes("");
    } else if (type === "view") {
      DownloadFileFromS3(object, type);
      setIsRightSidePannel(true);
    }
  };

  const onReceivePropsHandler = (pannel, load, type) => {
    if (type !== "") {
      setIsRightSidePannel(pannel);
      // setIsLoadDoc(load);
    } else if (type === "Download") {
      // DownloadFileFromS3(pannel, load);
    }
  };

  const docData = useSelector((state) => state.Downloaddocument.data);
  const { storedApplicant } = useSelector((state) => state.SelectedApplicant);
  const [DocName, setDocName] = useState("");

  const DownloadFileFromS3 = async (object, type) => {
    type = type === "view" ? "preview" : ""; //"download"
    if (componentType === "AssociatedJobs") {
      let applicantId = storedApplicant?.id ? storedApplicant?.id : JobId;
      dispatch(_ser.downloaddocumentAsync(applicantId, type, object.id));
    } else {
      dispatch(_ser.downloaddocumentAsync(showResumes.id, type, object.docsid));
    }
    setActionType(type);
    setDocName(object.path);
  };

  useEffect(() => {
    if (docData) {
      if (actionType === "Download" || actionType === "download") {
        const link = document.createElement("a");
        link.href = docData;
        link.download = DocName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setPreviewType(docData);
      }
      dispatch(_ser.downloaddocumentStartReducer(initalState));
    }
  }, [docData]);

  const getPrimaryDocType = (array) => {
    let fileType = "";
    if (array) {
      array?.forEach((doc) => {
        if (doc.primaryResume === 1) {
          fileType = doc.fileType;
        }
      });
    }
    return fileType;
  };

  return (
    <>
      {showSearchBar && (
        <div className="resultHeader">
          <SearchBar
            className="rightnavsearchbar"
            placeholder={searchKeyWord}
            //Search by JobCode, Title
            // value={searchValue !== null ? searchValue : ''}
            onChange={(newValue) => onSearchhandler(newValue, "search")}
            onRequestSearch={(newValue) =>
              // onSearchhandler(newValue.slice(0, 8), "onRequestSearch")
              onSearchhandler(newValue, "onRequestSearch")
            }
            onCancelSearch={() => onSearchhandler("", "onCancelSearch")}
          />
        </div>
      )}
      {jobData !== "null" &&
      jobData !== null &&
      jobData !== undefined &&
      jobData.length > 0 ? (
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p style={{ color: "#3B4046", fontWeight: "700", fontSize: "20px" }}>
            Results
          </p>
          <Pagination
            currentPage={currentPage}
            totalCount={totalRecords}
            pageSize={usersPerPage}
            onPageChange={(page) => handleActionClick(page)}
          />
        </div>
      ) : (
        ""
      )}
      {jobData !== "null" &&
        jobData !== null &&
        jobData !== undefined &&
        jobData?.length > 0 && (
          <div
            className="innerdiv"
            style={{
              maxHeight:
                isAssociate === false ? "calc(100vh - 431px)" : "initial",
              overflow:
                isAssociate === false && jobData.length > 2 ? "auto" : "",
              padding: isAssociate === false ? "0 0 6px 4px" : "",
            }}
          >
            {jobData?.map((elem, index) => {
              return (
                <>
                  <aside
                    onClick={(e) => {
                      if (alreadyAssociatedIds.includes(parseInt(elem.id))) {
                        return;
                      }
                      handleShowResumes(elem);
                    }}
                    style={{ position: "relative", cursor: "pointer" }}
                    className={`${
                      selectedIds.includes(parseInt(elem.id)) &&
                      showResumes.id === elem.id
                        ? "resumesCardCSS active"
                        : showResumes.id === elem.id
                          ? "resumesCardCSS"
                          : selectedIds.includes(parseInt(elem.id)) &&
                              elem.score
                            ? elem.associatedDocId === elem.docsId
                              ? "active"
                              : ""
                            : selectedIds.includes(parseInt(elem.id))
                              ? "active"
                              : componentType === "AssociatedProjects"
                                ? "projectCards"
                                : ""
                    } ${alreadyAssociatedIds.includes(parseInt(elem.id)) ? "already-associated" : ""}`}
                  >
                    {componentType === "AssociatedJobs" ? (
                      <>
                        <div className="cardbgcolor" title={elem.jobCode}>
                          {elem.jobCode}
                        </div>
                        {showResumes.id === elem.id && (
                          <div
                            className={
                              selectedIds.includes(parseInt(elem.id)) &&
                              showResumes.id === elem.id
                                ? "hideBorderActivejobs"
                                : "hideBorderjobs"
                            }
                          ></div>
                        )}
                        <div
                          className={
                            componentType === "AssociatedJobs"
                              ? "cardsforassjobs"
                              : " "
                          }
                        >
                          {/* {isAssociate !== false && <span title={elem.clientName}>{elem.clientName}</span> } */}
                          <div
                            style={{
                              display: "flex",
                              position: "absolute",
                              top: "12px",
                              right: "12px",
                            }}
                          >
                            {alreadyAssociatedIds.includes(
                              parseInt(elem.id),
                            ) ? (
                              <span className="addedBadge">
                                Added to Project
                              </span>
                            ) : (
                              <>
                                <IconButton
                                  size="small"
                                  onClick={(e) => onNavigeteInNew(e, elem)}
                                >
                                  <OpenInNewIcon className="newTab-btn" />
                                </IconButton>
                                <span className="resumecount">view</span>
                              </>
                            )}
                          </div>
                          <p
                            title={elem.jobTitle}
                            className="titleShowEllipsis"
                            style={{
                              cursor: isAssociate === false ? "pointer" : "",
                            }}
                          >
                            {" "}
                            {elem.jobTitle}
                          </p>{" "}
                          {/* onClick={()=> {if(isAssociate === false){handleShowResumes(elem)}}}  */}
                          {isAssociate === false && (
                            <>
                              <p
                                title={elem.clientName}
                                style={{ cursor: "pointer", display: "block" }}
                              >
                                {" "}
                                {elem.clientName}
                              </p>
                              <p
                                title={elem.location}
                                className="titleShowEllipsis"
                                style={{ cursor: "pointer", display: "block" }}
                              >
                                {" "}
                                {elem.location}
                              </p>
                              <p
                                title={elem.createdAt}
                                style={{
                                  cursor: "pointer",
                                  display: "block",
                                  bottom: "0px",
                                  position: "absolute",
                                  fontSize: "14px",
                                }}
                                className="uploadedDate"
                              >
                                {" "}
                                {GetTimeZone(elem.createdAt)}
                              </p>
                            </>
                          )}
                          {isAssociate !== false && (
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                                margin: "3px 70px 0px 0px",
                                gap: "10px",
                                alignItems: "baseline",
                              }}
                              className="resumedesc"
                            >
                              {!selectedIds.includes(parseInt(elem.id)) ||
                              showResumes.id === elem.id ? (
                                <>
                                  <div
                                    style={{
                                      justifyItems: "center",
                                      gap: "10px",
                                      display: "flex",
                                      height: "21px",
                                    }}
                                  >
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        `/assests/img/${elem.fileType === "pdf" || getPrimaryDocType(elem.docsarray) === "pdf" ? "pdf" : "docx"}.svg`
                                      }
                                      alt=""
                                      className="resumepdficon"
                                    />
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        textDecoration:
                                          documents.length == 1
                                            ? "underline"
                                            : "",
                                      }}
                                    >
                                      {documents.length > 1
                                        ? `${documents.length} Resumes`
                                        : documents.length == 1
                                          ? documents[0].name
                                          : ""}
                                    </span>
                                  </div>
                                  {documents.length == 1 ? (
                                    <span
                                      style={{ marginTop: "-5px" }}
                                      className="uploadedDate"
                                    >
                                      {documents[0].firstName +
                                        " " +
                                        documents[0].lastName +
                                        ", " +
                                        GetTimeZone(
                                          documents[0].docscreatedDate,
                                        )}
                                    </span>
                                  ) : (
                                    ""
                                  )}
                                </>
                              ) : selectedIds.includes(parseInt(elem.id)) &&
                                showResumes.id !== elem.id ? (
                                <>
                                  <div
                                    style={{
                                      justifyItems: "center",
                                      gap: "10px",
                                      display: "flex",
                                      height: "21px",
                                    }}
                                  >
                                    <img
                                      src={
                                        process.env.PUBLIC_URL +
                                        `/assests/img/${elem.fileType === "pdf" || selectedResume?.fileType === "pdf" || getPrimaryDocType(documents) === "pdf" ? "pdf" : "docx"}.svg`
                                      }
                                      alt=""
                                      className="resumepdficon"
                                    />
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        textDecoration: "underline",
                                        color: "#3E3E3E",
                                      }}
                                    >
                                      {elem.docName
                                        ? elem.docName
                                        : selectedResume?.name
                                          ? selectedResume?.name
                                          : ""}
                                    </span>
                                  </div>
                                  <span
                                    style={{ marginTop: "-5px" }}
                                    className="uploadedDate"
                                  >
                                    {(elem?.uploadedBy
                                      ? `${elem?.uploadedBy + ", "}`
                                      : selectedResume?.uploadedBy
                                        ? `${selectedResume?.uploadedBy + ", "}`
                                        : "") +
                                      // ', ' +
                                      (elem.lastUpdated
                                        ? elem.lastUpdated
                                        : selectedResume?.docscreatedDate
                                          ? GetTimeZone(
                                              selectedResume.docscreatedDate,
                                            )
                                          : "")}
                                  </span>
                                  {documents.length - 1 > 0 && (
                                    <div
                                      onClick={() => handleShowResumes(elem)}
                                      style={{ marginTop: "-5px" }}
                                    >
                                      <span
                                        style={{
                                          cursor: "pointer",
                                          marginTop: "-5px",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {`View Resumes` + " "}
                                      </span>
                                      <span>{`(${documents.length - 1})`}</span>
                                    </div>
                                  )}
                                </>
                              ) : (
                                " "
                              )}
                            </div>
                          )}
                        </div>
                        {isAssociate !== false &&
                          selectedIds.includes(parseInt(elem.id)) && (
                            <Checkbox
                              className={
                                selectedIds.includes(parseInt(elem.id)) &&
                                showResumes.id !== elem.id
                                  ? "cardcheckboxjobs"
                                  : selectedIds.includes(parseInt(elem.id)) &&
                                      showResumes.id === elem.id
                                    ? "cardcheckboxActivejobs"
                                    : ""
                              }
                              checked={
                                selectedIds.includes(parseInt(elem.id))
                                  ? true
                                  : false
                              }
                              onClick={() => onSelectHandler(elem)}
                            />
                          )}
                      </>
                    ) : componentType === "AssociatedApplicants" ? (
                      <>
                        {elem.applicantCode ? (
                          <div
                            className="cardbgcolor"
                            title={elem.applicantCode}
                          >
                            {elem.applicantCode}
                            {showResumes.id === elem.id && (
                              <div
                                className={
                                  selectedIds.includes(parseInt(elem.id)) &&
                                  showResumes.id === elem.id
                                    ? "hideBorderActive"
                                    : "hideBorder"
                                }
                              ></div>
                            )}
                          </div>
                        ) : (
                          <div style={{ height: "25px" }}></div>
                        )}
                        <div>
                          {/* {elem.jobTitle && (<div title={elem.jobTitle}>{elem.jobTitle}</div>)} */}
                          {elem.applicantCode && (
                            <>
                              <span
                                title={`${elem.firstName} ${elem.lastName}`}
                              >
                                {" "}
                                {elem.firstName} {elem.lastName}
                              </span>
                              <div
                                style={{
                                  display: "flex",
                                  position: "absolute",
                                  top: "12px",
                                  right: "30px",
                                }}
                              >
                                <IconButton
                                  style={{ marginLeft: "57%" }}
                                  size="small"
                                  onClick={(e) => onNavigeteInNew(e, elem)}
                                >
                                  <OpenInNewIcon className="newTab-btn" />
                                </IconButton>
                                <span className="resumecount">view</span>
                              </div>
                              <div
                                style={{
                                  marginTop: "20px",
                                  right: "18px",
                                  position: "absolute",
                                }}
                              >
                                {elem.score ? (
                                  <div className="mathCards">
                                    <Box
                                      position="relative"
                                      display="inline-flex"
                                    >
                                      <CircularProgress
                                        variant="determinate"
                                        value={elem.score * 100}
                                      />
                                      <Box
                                        top={0}
                                        left={5}
                                        bottom={10}
                                        right={0}
                                        position="absolute"
                                        display="flex"
                                        alignItems="center"
                                        justifyContent="center"
                                      >
                                        <Typography variant="caption">{`${Math.round(elem.score * 100)}%`}</Typography>
                                      </Box>
                                    </Box>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </>
                          )}
                          {/* <div onClick={() => onSelectHandler(elem)}>
                            {elem.contactNumber && (<p title={elem.contactNumber}> {elem.contactNumber}</p>)}
                            {elem.emailId && (<p title={elem.emailId}> {elem.emailId}
                            </p>)}
                          </div> */}

                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              margin: "10px 70px 0px 0px",
                              gap: "9px",
                              alignItems: "baseline",
                              width: "175px",
                              overflow: "hidden",
                            }}
                            className="resumecount"
                          >
                            {!selectedIds.includes(parseInt(elem.id)) ||
                            (elem.docsId
                              ? !selectedDocId.includes(parseInt(elem.docsId))
                              : !selectedDocId.includes(
                                  parseInt(elem.associatedDocId),
                                )) ||
                            showResumes.id === elem.id ? (
                              <>
                                <div
                                  style={{
                                    justifyItems: "center",
                                    gap: "10px",
                                    display: "flex",
                                    height: "21px",
                                  }}
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      `/assests/img/${elem.fileType === "pdf" || getPrimaryDocType(elem.docsarray) === "pdf" ? "pdf" : "docx"}.svg`
                                    }
                                    alt=""
                                    className="resumepdficon"
                                  />
                                  <span
                                    onClick={() => handleShowResumes(elem)}
                                    className="resumedesc"
                                    style={{
                                      cursor: "pointer",
                                      textDecoration:
                                        elem.docsarray?.length == 1 ||
                                        elem.documentName
                                          ? "underline"
                                          : "",
                                    }}
                                  >
                                    {elem.docsarray?.length > 1
                                      ? `${elem.docsarray?.length} Resumes`
                                      : elem.docsarray?.length == 1
                                        ? elem.docsarray[0].name
                                        : elem.associatedDocId === elem.docsId
                                          ? elem.docName
                                          : elem.documentName}
                                  </span>
                                </div>
                                {elem.docsarray?.length == 1 ? (
                                  <span
                                    style={{ marginTop: "-5px" }}
                                    className="uploadedDate"
                                  >
                                    {(elem.docsarray[0].submittedByName
                                      ? elem.docsarray[0].submittedByName
                                      : "") +
                                      ", " +
                                      (elem.docsarray[0].docscreatedDate
                                        ? elem.docsarray[0].docscreatedDate
                                        : "")}
                                  </span>
                                ) : elem.documentName ? (
                                  <span
                                    style={{ marginTop: "-5px" }}
                                    className="uploadedDate"
                                  >
                                    {(elem.associatedDocId === elem.docsId
                                      ? elem.docUploadedBy
                                      : elem.documentSubmittedBy) +
                                      ", " +
                                      (elem.associatedDocId === elem.docsId
                                        ? elem.docLastUpdated
                                        : GetTimeZone(elem.docscreatedDate))}
                                  </span>
                                ) : (
                                  " "
                                )}
                              </>
                            ) : selectedIds.includes(parseInt(elem.id)) &&
                              (selectedDocId.includes(parseInt(elem.docsId)) ||
                                selectedDocId.includes(
                                  parseInt(elem.associatedDocId),
                                )) &&
                              showResumes.id !== elem.id ? (
                              <>
                                <div
                                  style={{
                                    justifyItems: "center",
                                    gap: "10px",
                                    display: "flex",
                                    height: "21px",
                                  }}
                                  className="resumedesc"
                                >
                                  <img
                                    src={
                                      process.env.PUBLIC_URL +
                                      `/assests/img/${elem.fileType === "pdf" || getPrimaryDocType(elem.docsarray) === "pdf" ? "pdf" : "docx"}.svg`
                                    }
                                    alt=""
                                    className="resumepdficon"
                                  />
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      textDecoration: "underline",
                                    }}
                                  >
                                    {elem.docName
                                      ? elem.docName
                                      : elem.documentName
                                        ? elem.documentName
                                        : selectedResume?.docsarray?.length == 1
                                          ? selectedResume?.docsarray[0]?.name
                                          : ""}
                                  </span>
                                </div>
                                <span
                                  style={{ marginTop: "-5px" }}
                                  className="uploadedDate"
                                >
                                  {(elem.docUploadedBy
                                    ? elem.docUploadedBy
                                    : elem.documentSubmittedBy
                                      ? elem.documentSubmittedBy
                                      : selectedResume?.docsarray?.length == 1
                                        ? selectedResume?.docsarray[0]
                                            .uploadedBy
                                        : selectedResume.uploadedBy) +
                                    ", " +
                                    (elem.docLastUpdated
                                      ? elem.docLastUpdated
                                      : elem?.docsarray
                                        ? GetTimeZone(
                                            elem?.docsarray?.[0]
                                              ?.docscreatedDate,
                                          )
                                        : GetTimeZone(elem.docscreatedDate))}
                                </span>
                                {elem.docsarray?.length - 1 > 0 && (
                                  <div
                                    className="resumedesc"
                                    style={{ marginTop: "-5px" }}
                                  >
                                    <span
                                      style={{
                                        cursor: "pointer",
                                        marginTop: "-5px",
                                        textDecoration: "underline",
                                      }}
                                    >
                                      {`View Resumes` + " "}
                                    </span>
                                    <span>{`(${elem.docsarray?.length - 1})`}</span>
                                  </div>
                                )}
                              </>
                            ) : (
                              " "
                            )}
                          </div>
                          {(elem.score
                            ? elem.associatedDocId === elem.docsId
                            : selectedIds.includes(parseInt(elem.id))) && (
                              <>
                            <Checkbox
                              className={
                                selectedIds.includes(parseInt(elem.id)) &&
                                showResumes.id !== elem.id &&
                                elem.docsarray?.length - 1 > 0
                                  ? "cardcheckbox"
                                  : selectedIds.includes(parseInt(elem.id)) &&
                                      showResumes.id === elem.id
                                    ? "cardcheckboxActive"
                                    : selectedIds.includes(parseInt(elem.id)) &&
                                        elem.docsarray?.length == 1
                                      ? "checkboxSingledoc"
                                      : "aiCardcheckbox"
                              }
                              checked={
                                selectedIds.includes(parseInt(elem.id))
                                  ? true
                                  : false
                              }
                              onClick={() => onSelectHandler(elem)}
                            />
                            </>
                          )}
                        </div>
                      </>
                    ) : componentType === "AssociatedProjects" ? (
                      <>
                        <div
                          className="cardbgcolor"
                          title={elem.name}
                          onClick={() => {
                            onReceiveHandler(elem, "AssociatProject");
                          }}
                        >
                          {elem.name}
                        </div>
                        <div
                          className="cardsforassjobs"
                          onClick={() => {
                            onReceiveHandler(elem, "AssociatProject");
                          }}
                        >
                          <p title={elem.projectCode}> {elem.projectCode}</p>
                          <p style={{ marginTop: "10px" }}>
                            No of applicants in project : &nbsp;
                            <b>{elem.totalCount}</b>
                          </p>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                    {showResumes.id === elem.id && (
                      <>
                        <div
                          className={
                            selectedIds.includes(parseInt(elem.id)) &&
                            componentType === "AssociatedJobs"
                              ? "resumeTabledivJobs"
                              : "resumeTablediv"
                          }
                          style={{
                            marginLeft:
                              index === 0
                                ? "-1px"
                                : index > 2
                                  ? "-" +
                                    (index % 3 === 0 ? 1 : 275) *
                                      (index % 3 === 0 ? 1 : index % 3) +
                                    "px"
                                  : "-" + 275 * index + "px",
                          }}
                        >
                          {documents.length > 0 && (
                            <DynamicTable
                              config={configuration}
                              data={
                                documents.length > 0
                                  ? documents
                                  : elem.docsarray
                              }
                              selectedId={
                                elem.associatedDocId ? elem.associatedDocId : ""
                              }
                              colmns={columnsData}
                              actionDropdown={""}
                              actions={actionsList}
                              addModel={""}
                              noDataText={"No documents found"}
                              searchKeyWord="Search by Document Name"
                              onReceiveActionProps={(type, obj) =>
                                onReceiveActionHandler(type, obj)
                              }
                            />
                          )}
                          {documents.length === 0 && (
                            <DynamicTable
                              config={configuration}
                              data={
                                documents.length > 0
                                  ? documents
                                  : elem.docsarray
                              }
                              selectedId={
                                elem.associatedDocId ? elem.associatedDocId : ""
                              }
                              colmns={columnsData}
                              actionDropdown={""}
                              actions={actionsList}
                              addModel={""}
                              noDataText={"No documents found"}
                              searchKeyWord="Search by Document Name"
                              onReceiveActionProps={(type, obj) =>
                                onReceiveActionHandler(type, obj)
                              }
                            />
                          )}
                        </div>
                      </>
                    )}
                  </aside>
                </>
              );
            })}
          </div>
        )}
      {jobData.length === 0 && isNoData && (
        <div className="nodatasection nodataSection">
          <img
            src={process.env.PUBLIC_URL + "/assests/nodata.svg"}
            alt="noResult"
          />
          No search results found
        </div>
      )}

      {isRightSidePannel ? (
        <div id="associateResumes">
          <RightSideBar
            componentData={
              <ComponentRenderData
                JobId={JobId}
                previewType={previewType}
                DocName={DocName}
                onReceivechildProps={onReceivePropsHandler}
              />
            }
            componentLayout={pannelobj}
            onReceiveProps={onReceivePropsHandler}
          />
        </div>
      ) : (
        ""
      )}
    </>
  );
};

const ComponentRenderData = (props) => {
  const [docUrl, setDocUrl] = useState(null);

  const dispatch = useDispatch();

  useEffect(() => {
    if (props.previewType !== "") {
      setDocUrl(props.previewType);
    }
  }, [props]);

  return (
    <>
      <div style={{ textAlign: "center" }}>
        {docUrl !== null ? (
          <DocumentViewer
            url={docUrl}
            fileType={(() => {
              const cleanUrl = docUrl?.split("?")[0] || "";
              return cleanUrl.split(".").pop()?.toLowerCase();
            })()}
          ></DocumentViewer>
        ) : (
          ""
        )}
      </div>
    </>
  );
};

export default React.memo(AssociateCards);

// for dynamic Table config Object
const configuration = {
  isSearchbar: false,
  isPaging: true,
  isDropdownActions: false,
  isCheckbox: false,
  isActions: true,
  recordperPage: 10,
  currentPage: 1,
  totalRecords: 0,
  isTotalCount: false,
  totalRecordsCount: 0,
  totalRecordsCountText: "",
  limitData: 10,
  isPaginationTop: false,
  ischeckAlignRight: true,
  isSearchServer: false,
  isPagingServer: false,
  isPageRange: false,
};

// for dynamic Table row Action buttons
const actionsList = {
  isDownload: false,
  isPositingsView: true,
  isPostingsDownload: false,
  isDelete: false,
  isRadiobtn: true,
};

// for dynamic Table Headers and columns
const columnsData = [
  {
    id: 1,
    displayName: "Document Name",
    mappingName: "name",
    class: "",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center doctablebodytext",
    isEdit: false,
    nagigate: null,
    width: "200px",
  },
  {
    id: 2,
    displayName: "Date and Time",
    mappingName: "docscreatedDate",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center doctablebodytext",
    isEdit: false,
    nagigate: null,
    width: "200px",
  },
  {
    id: 3,
    displayName: "Uploaded by",
    mappingName: "uploadedBy",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center doctablebodytext",
    isEdit: false,
    nagigate: null,
    width: "200px",
  },
  {
    id: 4,
    displayName: "Action",
    mappingName: "Actions",
    theadClass: " text-center doctableheadtext",
    tbodyClass: " text-center documentposttime",
    isEdit: false,
    width: "150px",
    nagigate: null,
  },
];

const pannelobj = {
  title: "Document view",
  description: "",
  bgImage: "",
};
